import React, { HTMLAttributes } from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Text } from '../../../components';
import { ParagraphText as Type } from '../../../types/uncinc_profile/paragraphs';
import './style.scss';

interface ParagraphTextProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphText: React.FC<ParagraphTextProps> = ({
  entity,
}) => {
  const paragraphText = entity.toJS();

  const title = paragraphText.field_title[0]?.value;
  const body = paragraphText.field_body[0].processed || '';
  const link = paragraphText.field_link[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;
  const secondaryLink = paragraphText.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUri = secondaryLink?.alias || secondaryLink?.uri;
  const secondaryLinkTarget = secondaryLink?.options?.attributes?.target;

  return (
    <div className="Paragraph ParagraphText">
      <Container small>
        <Text
          title={title}
          text={body}
          link={linkUri}
          linkText={linkTitle}
          target={linkTarget}
          secondaryLink={secondaryLinkUri}
          secondaryLinkText={secondaryLinkTitle}
          secondaryTarget={secondaryLinkTarget}
          buttonClassName="Button--secondary icon-after icon-arrow-right icon-variant-2"
          buttonPrimary={false}
          secondaryButtonClassName="Button--textual icon-after icon-arrow-right icon-variant-4"
          secondaryButtonPrimary={false}
        />
      </Container>
    </div>
  );
};

export default ParagraphText;
